export default {
  'realm': 'athlinks',
  'auth-server-url': 'https://accounts-stage.athlinks.com/auth',
  'url': 'https://accounts-stage.athlinks.com/auth',
  'ssl-required': 'external',
  'clientId': 'admin',
  'resource': 'admin',
  'public-client': true
}
